import { render } from "./IndexChild.vue?vue&type=template&id=d9b145b8"
import script from "./IndexChild.vue?vue&type=script&lang=js"
export * from "./IndexChild.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaimevalencia/Documents/PROYECTOS/SERVIDOR_GIT/soporte_bis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__